var App = App || {};

App.SkipCTAs = (function ($) {
    "use strict";

    function init() {
        $(".skip-ctas").click(function () {
            
            var skipTarget = this.getAttribute('data-skip-target');
            var skipTargetAttribute = this.getAttribute('data-skip-attribute');

            $(`[${skipTargetAttribute}='${skipTarget}']`).get(0).scrollIntoView();


        });
    }

    return {
        init: init
    };
})(jQuery);

$(function () {
    App.SkipCTAs.init();
});